import Vue from 'vue'
import Router from 'vue-router'

// Import modules
import store from './store'
import { notif } from './pop'

Vue.use(Router)

import views from './views'

const router = new Router({
	//mode: process.env.CORDOVA_PLATFORM ? 'hash' : 'history',
	mode: 'history',
	base: process.env.BASE_URL,

	scrollBehavior(to, from, savedPosition) {

		if (to.hash)
			return {
				selector: to.hash,
				offset: { x: 0.0, y: 100.0 }
			}
		else
			return savedPosition
	},

	routes: [
		{
			path: '/',
			name: 'home',
			component: views.Home
		},

		// All posts
		{
			path: '/posts',
			name: 'posts',
			component: views.Posts,
			meta: { robots: "noindex",  title: "Blog", desc: "Leggi i nostri ultimi articoli sull'allenamento e non solo!" }
		},

		// ebook tag
		{
			path: '/ebook',
			name: 'ebook',
			component: views.Home
		},

		// Thank You Page
		{
			path: '/thankyou',
			name: 'thankyou',
			component: views.Thankyou
		},

		// Thank You Page Ebook 1
		{
			path: '/grazie',
			name: 'grazie',
			component: views.grazie_ebook1
		},

		// Thank You Page Ebook 2
		{
			path: '/grazie-2',
			name: 'grazie-2',
			component: views.grazie_ebook2
		},

		// Thank You Page Ebook 3
		{
			path: '/grazie-new',
			name: 'grazie-new',
			component: views.grazie_ebook3
		},

		// Thank You Page Ebook ginocchia
		{
			path: '/grazie-ginocchia',
			name: 'grazie-ginocchia',
			component: views.grazie_ginocchia
		},

		// Page Ebook 3
		{
			path: '/comeviveremeglio',
			name: 'comeviveremeglio',
			component: views.ebook3
		},

		// Page Ebook 3
		{
			path: '/ginocchiaindistruttibili',
			name: 'ginocchiaindistruttibili',
			component: views.ebook_knee
		},

		// Page schede estate
		{
			path: '/schede-estate-2025',
			name: 'schede-estate',
			component: views.schedeestate,
			meta: { title: "Schede estate 2025", desc: "Scarica le nostre schede gratuite per allenarti in vacanza con noi! Scegli se allenarti a corpo libero o con attrezzi.", keywords: ["schede", "gratis", "allenamento", "estate", "vacanze"] }
		},


		// Thank You Page Scheda
		{
			path: '/grazie-3',
			name: 'grazie-3',
			component: views.grazie_scheda
		},

		// Thank You Page Scheda Estate corpo libero
		{
			path: '/grazie-4',
			name: 'grazie-4',
			component: views.grazie_estate1
		},

		// Thank You Page Scheda Estate attrezzi
		{
			path: '/grazie-5',
			name: 'grazie-5',
			component: views.grazie_estate2
		},

		// shop page services
		{
			path: '/shop',
			name: 'shop',
			component: views.shop_page
		},

		// eximusdaita page services
		{
			path: '/eximusdaita',
			name: 'eximusdaita',
			component: views.eximusdaita_page,
			meta: { title: "Allenamento e Nutrizionista", desc: "Scopri i nostri pacchetti personal trainer e nutrizionista, con pagamento mensile potrai raggiungere i tuoi obiettivi. 6 o 12 mesi per cambiare il tuo corpo a seregno monza brianza in palestra e dieta.", keywords: ["nutrizionista", "dieta", "allenamento", "personal trainer", "pacchetto"] }
		},

		// pagina contatti per forma prova
		{
			path: '/provagratuita',
			name: 'provagratuita',
			component: views.contacts_page,
			meta: { title: "Prova Gratuita", desc: "Prenota ora la tua prova gratuita in palestra con personal trainer a seregno di allenamento funzionale o preparazione atletica. Allenamenti mirati in base alle tue esigenze sempre seguiti su appuntamento a seregno monza brianza", keywords: ["prova", "gratuita", "allenamento", "personal trainer", "palestra", "seregno", "funzionale"] }
		},

		// pagina servizi
		{
			path: '/servizi',
			name: 'servizi',
			component: views.services_page,
			meta: { title: "Personal Training, Small Class", desc: "Riceviamo solo su appuntamento con personal trainer singolo o di gruppo in small class, allenamento personalizzato, test di movimento e posturali, allenamento in gravidanza, preparazione atletica, recupero infortuni.", keywords: ["servizi", "small", "class", "personal trainer", "monza", "seregno", "brianza"] }
		},

		// pagina chi siamo
		{
			path: '/chisiamo',
			name: 'chisiamo',
			component: views.about_page,
			meta: { title: "Chi Siamo", desc: "Palestra con Team di personal trainer professionisti dell’allenamento e del movimento a seregno monza brianza. Allenamento personalizzato in base alle tue esigenze per ogni obiettivo", keywords: ["chi", "siamo", "class", "personal trainer", "monza", "seregno", "brianza"] }
		},

		// promo page services
		{
			path: '/natale',
			name: 'natale',
			component: views.promo_page,
			meta: { robots: "noindex" }
		},

		// running analysis page
		{
			path: '/analisicorsa',
			name: 'analisicorsa',
			component: views.running,
			meta: { title: "Analisi Corsa Online", desc: "Riduci gli infortuni e migliora la tua performance, con un'analisi biomeccanica della corsa fatta dai nostri esperti. Scopri i nostri pacchetti per imparare a correre senza più dolori.", keywords: ["corsa", "analisi", "tecnica", "infortuni", "valutazione", "online"] }
		},

		// test page services
		{
			path: '/test',
			name: 'test',
			component: views.test_page,
			meta: { title: "Test Movimento", desc: "Test di movimento e performance che daranno risultati chiari e scientifici per poi strutturare un programma personalizzato con personal trainer in palestra a seregno monza brianza di allenamento funzionale, posturale o preparazione atletica", keywords: ["test", "funzionale", "atleta", "movimento", "valutazione"] }
		},

		// Article page
		{
			path: '/post/:slug',
			name: 'post',
			component: views.Post
		},

		// Login page
		{
			path: '/login',
			name: 'login',
			component: views.Login,
			meta: { robots: "noindex" }
		},

		// Library page
		{
			path: '/eximus-online-training',
			name: 'eximus-online-training',
			component: views.Library,
			meta: { robots: "noindex" }
		},

		// Forgot Password
		{
			path: '/reset-password',
			name: 'reset-password',
			component: views.reset_password,
			meta: { robots: "noindex" }
		},

		// First access
		{
			path: '/first-access',
			name: 'first_access',
			component: views.FirstAccess,
			meta: { authRequired: true }
		},

		// Profile page
		{
			path: '/me',
			name: 'dashboard',
			component: views.Dashboard
		},

		// Admin page
		{
			path: '/admin',
			name: 'admin',
			component: views.Admin,
			redirect: { name: 'admin.users' },

			children: [
				{
					path: 'activity',
					name: 'admin.activity',
					component: () => import('./components/admin/AddUser')
				},
				{
					path: 'users',
					name: 'admin.users',
					component: () => import('./components/admin/AddUser')
				},
				{
					path: 'users/:userid/subscriptions',
					name: 'admin.user.subscriptions',
					component: () => import('./components/admin/UserClassSubscriptions'),
					meta: { title: 'Storico iscrizioni' }
				},
				{
					path: 'events',
					name: 'admin.events',
					component: () => import('./components/admin/Events'),
					meta: { title: 'Iscritti Class'}
				},
				{
					path: 'ranking',
					name: 'admin.ranking',
					component: () => import('./components/admin/UserRanking.vue'),
					meta: { title: 'Classifica clienti' }
				}
			]
		}
	]
})

function setTitle(to) {
	let title = to.matched.map(route => route.meta.title).join(' ')
	let desc = to.matched.map(route => route.meta.desc).join(' ')
	let robots = to.matched.map(route => route.meta.robots).join(' ')
	let keywords = to.matched.map(route => (route.meta.keywords || []).join(', ')).join(', ')
	//TODO: set the title, like:
	document.title = title || "Palestra Eximus Performance a Seregno - Personal trainer, corsi, riabilitazione"
	if (desc) {
		document.getElementsByTagName("meta").namedItem("description").setAttribute("content", desc)
	} else {
		document.getElementsByTagName("meta").namedItem("description").setAttribute("content", "Palestra a Seregno, personal trainer qualificati, nessun abbonamento, corsi di gruppo e allenamenti personalizzati! Prenota ora la tua prova gratuita!")
	}
	
	if (keywords) {
		document.getElementsByTagName("meta").namedItem("keywords").setAttribute("content", keywords)
	} else {
		document.getElementsByTagName("meta").namedItem("keywords").setAttribute("content", "palestra, personal trainer, monza, seregno, funzionale, allenamento, ginnastica posturale, corsi, class")
	}

	if (robots) {
		document.getElementsByTagName("meta").namedItem("robots").setAttribute("content", robots)
	} else {
		document.getElementsByTagName("meta").namedItem("robots").setAttribute("content", "all")
	}
}

/**
 * Route guard, called before each route is matched
 */
router.beforeEach(async (to, from, next) => {

	if (to.matched.some((route) => route.meta.authRequired)) {
		// Check auth
		try {
			await store.dispatch('auth/check')
			setTitle(to)
			next()
		}
		catch (err) {
			next({
				name: 'login',
				query: { redirect_url: to.fullPath }
			})
		}
	}
	else {
		setTitle(to)
		next()
	}
})

export default router